module.exports = __webpack_public_path__ + "static/media/icon_driver.e879493e.png";